import { z } from 'zod';

export const createUserProfileValidator = z.object({
  userId: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  contactNumber: z.string(),
  country: z.string(),
  state: z.string(),
  line1: z.string(),
  line2: z.string().optional(),
  city: z.string(),
  postcode: z.string(),
});

export type CreateUserProfileInput = z.infer<typeof createUserProfileValidator>;
